import React, { useEffect, useState } from 'react';
import '../styles/MiddleSection.css';
import CreateIcon from "@material-ui/icons/Create";
import ImageIcon from "@material-ui/icons/Image"
import InputOption from "./InputOption";
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import EventNoteIcon from '@material-ui/icons/EventNote';
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay';
import Post from './Post';
import { db } from '../firebase';
import firebase from 'firebase';
import { useSelector } from 'react-redux';
import { fetchUser } from '../features/UserSlice';

function MiddleSection(props) {

    const loggedInUser = useSelector(fetchUser);

    //create a piece of state for the inputs
    const [input, setInput] = useState('');


    const[posts,setPosts] = useState([]);

    useEffect(()=>{
        db.collection("posts")
        .orderBy("timestamp","desc")
        .onSnapshot((snapshot) =>
            setPosts(snapshot.docs.map((doc)=>(
                {
                    id: doc.id,
                    data: doc.data()
                }
            ))
        )
        );
    },[]);


    const sendPost =(e)=>{
        e.preventDefault();
       // setPosts([...posts,'hello'])

       db.collection('posts').add({
           name: loggedInUser.displayName,
           description: loggedInUser.email,
           message: input,
           photoUrl: loggedInUser.photoUrl || loggedInUser.displayName[0],
           timestamp: firebase.firestore.FieldValue.serverTimestamp()
       });

       setInput("");
    };

    return (
        <div className="feed">
            <div className="middle_section_top">
                <div className="feed_input">
                    <CreateIcon/>
                    <form>
                        <input type='text' value={input} onChange ={e=>setInput(e.target.value)} placeholder="Start a post"/>
                        <button onClick={sendPost} type='submit'>Send</button>
                    </form>
                </div>

                <div className="feed_options">
                    <InputOption Icon={ImageIcon}  title="Photo" color="blue"/>                  
                    <InputOption Icon={SubscriptionsIcon}  title="Video" color="red"/>
                    <InputOption Icon={EventNoteIcon}  title="Event" color="yellow"/>
                    <InputOption Icon={CalendarViewDayIcon}  title="Write Article" color="green"/>
                </div>
            </div>
                {
                    posts.map(
                        ({id,data:{name,description,message,photoUrl}})=>(
                        <Post
                        key={id}
                        name={name}
                        description={description}
                        message={message}
                        photoUrl={photoUrl}/>
                    ))
                }            
        </div>
    );
}

export default MiddleSection;